import React from 'react';
import { AppButton, Box, Preloader } from '@common-fe/common-fe';

import { PendingModal } from '@/components/elements';
interface Props {
  visible: boolean;
  onSetVisible: (value: boolean) => void;
  onDeactivation: () => void;
  isLoading?: boolean;
}
const ScheduledReportItemDeactivationModal: React.FC<Props> = ({
  visible,
  onSetVisible,
  onDeactivation,
  isLoading,
}) => {
  return (
    <PendingModal
      visible={visible}
      onSetVisible={onSetVisible}
      header="Deactivate this schedule?"
      helptext="When you deactivate this schedule, it will stop generating reports on the scheduled dates. You won't receive any further reports until you reactivate it."
    >
      <Box data-testid="scheduled-modal_deactivation_modal" direction="row">
        <AppButton
          testId="scheduled-modal_deactivation_cancel"
          onClick={() => onSetVisible(true)}
          width="240px"
          buttonType="secondary"
        >
          Cancel
        </AppButton>
        <Box margin={{ right: 'spacing12' }}></Box>
        <AppButton
          testId="scheduled-modal_deactivation_apply"
          color="red"
          disabled={isLoading}
          onClick={onDeactivation}
          width="240px"
        >
          {isLoading ? <Preloader testId="scheduled-modal_deactivation_apply_loading" /> : 'Yes, Deactivate'}
        </AppButton>
      </Box>
    </PendingModal>
  );
};

export default ScheduledReportItemDeactivationModal;
